import Vue from "vue"
import Router from "vue-router"
import Index from "@/components/home/Index.vue"
import Career from "@/components/pages/Career.vue"
import Genetics from "@/components/pages/Genetics.vue"
import Yolo from "@/components/pages/Yolo.vue"
import Chaos from "@/components/pages/Chaos.vue"

import Test from "@/components/pages/test.vue"



Vue.use(Router)

export default new Router({
    routes:[
        {
        path: "/",
        name: "Index",
        component: Index,
        meta: {
            title: 'TJ-Portfolio',
            metaTags: [
              {
                content: 'TJ-Portfolio',
                property: 'og:title',
              },{
                property: 'og:description',
                content: 'Portfolio for showcasing my past projects.'
              },{
                property: 'og:image',
                content: require("@/assets/thumbnails/index.jpg")
              }
            ]
          }
    },{
        path: "/career",
        name: "Career",
        component: Career,
        metaTags: [
            {
              property: 'og:title',
              content: 'Deciding my career path using NLP'
            },{
              property: 'og:description',
              content: 'Suitable career path for the fictional character Tintin was found using NLP techniques. The program was then used on myself to determine suitable career path.'
            },{
              property: 'og:image',
              content: require("@/assets/thumbnails/career.gif")
            }
          ]
    },{
        path: "/genetics",
        name: "Genetics",
        component: Genetics ,
        metaTags: [
            {
              property: 'og:title',
              content: 'Controlling particle with charge using genetic algorithm'
            },{
              property: 'og:description',
              content: 'Portfolio for showcasing my past projects.'
            },{
              property: 'og:image',
              content: require("@/assets/thumbnails/genetic.gif")
            }
          ]
    },{
        path: "/chaos",
        name: "Chaos",
        component: Chaos,
        metaTags: [
            {
              property: 'og:title',
              content: 'Supporting a team by visualising lorenz attractor'
            },{
              property: 'og:description',
              content: 'I supported a team by writing a program that visualises the Lorenz attractor. The team used the program to confirm their findings visually.'
            },{
              property: 'og:image',
              content: require("@/assets/thumbnails/chaos.gif")
            }
          ]
    },{
        path: "/yolo",
        name: "Yolo",
        component: Yolo,
        metaTags: [
            {
              property: 'og:title',
              content: 'Real time face detection and masking using YOLO'
            },{
              property: 'og:description',
              content: 'You Only Look Once model was trained on the images to detect faces. The trained model was used to detect and mask a face in real time.'
            },{
              property: 'og:image',
              content: require("@/assets/thumbnails/yolo.gif")
            }
          ]
    },{
        path: "/test",
        name: "test",
        component: Test
    }
    ],
    scrollBehavior() {
        //Used to scroll to top when at new page
        window.scrollTo(0,0);
      }
})